import { useSearch } from '@tanstack/react-router'
import { useEffect, useState } from 'react'
import { useSpaceListView } from '../context/SpaceListViewContext'

/**
 * Returns the search params for spaces page in 2 parts:
 *  - `filters`: the filters for the spaces list
 *  - `createSpaceFromTemplate`: the id of the template to create a new space from
 */
export const useSpacesSearch = () => {
  const searchFilters = useSearch({ from: '/dashboard/spaces' })
  const { createSpaceFromTemplate, viewId, ...filters } = searchFilters
  const [stableFilters, setStableFilters] = useState(filters)
  const { localViewSettings } = useSpaceListView()

  // Update stable filters when view changes or URL filters change
  useEffect(() => {
    if (JSON.stringify(filters) !== JSON.stringify(stableFilters)) {
      setStableFilters(filters)
    }
  }, [filters, stableFilters])

  return { createSpaceFromTemplate, viewId, filters: stableFilters }
}

export type UseSpacesSearchResult = ReturnType<typeof useSpacesSearch>
